var module = angular.module('b2bLoginApp.directives');
module.directive('companyProfileErrorNotice', function () {
    return {
        restrict: 'E',
        template: '<div class="sd-mt-1 text-center" ng-class="{\'d-none\':!open}"><div class="alert alert-danger" role="alert"><span ng-bind-html="text"></span></div></div>',
        scope: {
            text: '@',
            open: '='
        }
    };
});
